var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-arrow-collapse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-collapse",
    clipPath: "url(#clip-arrow-collapse)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34098",
    "data-name": "Path 34098",
    d: "M106.125,8.986l-7.032,7.031a1.145,1.145,0,0,1-1.62-1.619L103.7,8.176,97.474,1.955A1.145,1.145,0,1,1,99.094.335l7.032,7.031a1.145,1.145,0,0,1,0,1.619Z",
    transform: "translate(17.237 -92.798) rotate(90)",
    fill: "#20bead"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCollapse);
export default __webpack_public_path__ + "static/media/arrow-collapse.6c19ff607dfbf1dec59e0f7c956470f1.svg";
export { ForwardRef as ReactComponent };